/**
 * Fetcher untuk Settings (admin CRUD) — paginated list dengan search.
 *
 * Berbeda dengan src/queries/api/master.js yang fetch pagination=false (untuk dropdown),
 * file ini untuk halaman Settings yang paginate dengan filter search.
 */
import http from "@/config/http";

function listFetcher(url) {
  return async function (params = {}) {
    const { data } = await http.get(url, {
      params: { pagination: true, page: 1, limit: 10, ...params },
    });
    return data;
  };
}

export const fetchBranchAdminList = listFetcher("/api/v1/master/branch/admin");
export const fetchBankAdminList = listFetcher("/api/v1/master/bank/admin");
export const fetchBankCourierAdminList = listFetcher(
  "/api/v1/master/bank-courier/admin"
);
export const fetchCourierAdminList = listFetcher(
  "/api/v1/shipping-rates/courier/admin"
);
export const fetchServiceAdminList = listFetcher(
  "/api/v1/shipping-rates/service/admin"
);
export const fetchPickupAdminList = listFetcher("/api/v1/master/pickup");
export const fetchJobAdminList = listFetcher("/api/v1/master/job/admin");
export const fetchCostCategoryAdminList = listFetcher(
  "/api/v1/master/cost-category"
);
export const fetchRoleAdminList = listFetcher("/api/v1/users/role");
export const fetchKaryawanAdminList = listFetcher("/api/v1/users/karyawan/get");
export const fetchUserAdminList = listFetcher("/api/v1/users/user");
export const fetchAgenAdminList = listFetcher("/api/v1/users/agen/get");
export const fetchMemberAdminList = listFetcher("/api/v1/users/member/get");
export const fetchDestinationAdminList = listFetcher(
  "/api/v1/shipping-rates/destination"
);

/* Detail by ID */
export async function fetchBranchById(id) {
  const { data } = await http.get(`/api/v1/master/branch/get/${id}`);
  return data;
}
export async function fetchBankById(id) {
  const { data } = await http.get(`/api/v1/master/bank/get/${id}`);
  return data;
}
export async function fetchBankCourierById(id) {
  const { data } = await http.get(`/api/v1/master/bank-courier/get/${id}`);
  return data;
}
export async function fetchCourierById(id) {
  const { data } = await http.get(`/api/v1/shipping-rates/courier/get/${id}`);
  return data;
}
export async function fetchServiceById(id) {
  const { data } = await http.get(`/api/v1/shipping-rates/service/get/${id}`);
  return data;
}
export async function fetchPickupById(id) {
  const { data } = await http.get(`/api/v1/master/pickup/get/${id}`);
  return data;
}
export async function fetchJobById(id) {
  const { data } = await http.get(`/api/v1/master/job/get/${id}`);
  return data;
}
export async function fetchCostCategoryById(id) {
  const { data } = await http.get(`/api/v1/master/cost-category/${id}`);
  return data;
}
export async function fetchRoleByIdAdmin(id) {
  const { data } = await http.get(`/api/v1/users/role/${id}`);
  return data;
}
export async function fetchKaryawanByIdAdmin(id) {
  const { data } = await http.get(`/api/v1/users/karyawan/get/${id}`);
  return data;
}
export async function fetchUserByIdAdmin(id) {
  const { data } = await http.get(`/api/v1/users/user/get/${id}`);
  return data;
}
export async function fetchAgenByIdAdmin(id) {
  const { data } = await http.get(`/api/v1/users/agen/get/${id}`);
  return data;
}
export async function fetchMemberByIdAdmin(id) {
  const { data } = await http.get(`/api/v1/users/member/get/${id}`);
  return data;
}
